/* Golf bets engine — pure functions, no DOM. Settles skins, a Nassau and
   Wolf from the scores on the card, by the rules our own guides state:
     /blogs/whysguyscorner/skins-game-golf
     /blogs/whysguyscorner/nassau-golf-bet
     /blogs/whysguyscorner/wolf-golf-game
   The worked scorecards in those three guides are the test cases in
   scripts/tests/golf-bets-engine.test.js.

   Players are numbered from 0 in the order entered. scores[player][hole] is
   a gross score, hole 0 to 17; anything that is not a whole number from 1 to
   20 means the hole was not played by that player, and a hole counts only
   when every player in the game has a score on it.

   NET SCORES  Strokes come off the lowest handicap in the group, so the low
               player plays at scratch, and fall on the hardest holes first
               by stroke index (Rules of Handicapping, Appendix E).
   SKINS   Lowest score alone wins the skin. A tie for low wins nothing and,
           with carryovers on, the skin rides to the next hole.
   NASSAU  Three match play bets at one stake: front nine, back nine, the 18.
           A press is a new bet at the same stake from the next hole to the
           end of that nine. Automatic presses open when a side goes 2 down
           in the latest bet on that nine; none starts on the 9th or 18th and
           the overall bet is never pressed.
   WOLF    Best ball, Wolf's side against the rest. Every loser pays every
           winner one point, doubled on a blind wolf, so points collected and
           points paid are both kept: money follows the net.
   Browser: window.WGBets.
   Node: require('./golf-bets-engine.js'). */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.WGBets = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var HOLES = 18;

  function isScore(v) {
    return typeof v === 'number' && isFinite(v) && v % 1 === 0 && v >= 1 && v <= 20;
  }
  function cents(amount) {
    return Math.round(amount * 100);
  }
  function range(n) {
    var out = [];
    for (var i = 0; i < n; i++) out.push(i);
    return out;
  }

  /* ---------- handicap strokes ---------- */

  // Strokes a playing handicap of h receives on a hole of this stroke index.
  function strokesOnHole(h, strokeIndex) {
    if (!(h > 0)) return 0;
    var every = Math.floor(h / HOLES);
    return every + (strokeIndex <= h % HOLES ? 1 : 0);
  }

  // Each stroke index 1 to 18, once.
  function validStrokeIndexes(list) {
    if (!Array.isArray(list) || list.length !== HOLES) return false;
    var seen = {};
    for (var i = 0; i < HOLES; i++) {
      var s = list[i];
      if (typeof s !== 'number' || s % 1 !== 0 || s < 1 || s > HOLES || seen[s]) return false;
      seen[s] = true;
    }
    return true;
  }

  // Playing handicaps off the low player. allowance is a fraction applied to
  // each course handicap first (0.9 in a four-ball Nassau), rounded .5 up.
  function playingHandicaps(handicaps, allowance) {
    var a = allowance === undefined ? 1 : allowance;
    var rounded = handicaps.map(function (h) { return Math.floor(Math.round(h * a * 1e9) / 1e9 + 0.5); });
    var low = Math.min.apply(null, rounded);
    return rounded.map(function (h) { return h - low; });
  }

  // options: { handicaps: [course handicap per player], strokeIndexes: [18], allowance }
  // Returns scores with the strokes taken off. Unplayed holes stay as they are.
  function netScores(scores, options) {
    var playing = playingHandicaps(options.handicaps, options.allowance);
    return scores.map(function (row, p) {
      return row.map(function (gross, h) {
        return isScore(gross) ? gross - strokesOnHole(playing[p], options.strokeIndexes[h]) : gross;
      });
    });
  }

  function holePlayed(scores, players, h) {
    for (var i = 0; i < players.length; i++) {
      if (!isScore(scores[players[i]][h])) return false;
    }
    return true;
  }

  /* ---------- skins ---------- */

  // options: { players: n, carryover: bool, leftover: 'none' | 'split' | 'playoff',
  //            playoffWinner: player, value: dollars, payout: 'each' | 'pot' }
  // scores may be gross or already net; low net can go below 1.
  function skins(scores, options) {
    var n = options.players;
    var players = range(n);
    var won = players.map(function () { return 0; });
    var holes = [];
    var carry = 0;
    var last = null;

    for (var h = 0; h < HOLES; h++) {
      var played = true;
      for (var p = 0; p < n; p++) {
        var v = scores[p] ? scores[p][h] : NaN;
        if (typeof v !== 'number' || !isFinite(v) || v % 1 !== 0) { played = false; break; }
      }
      if (!played) { holes.push({ hole: h + 1, played: false }); continue; }

      var low = Infinity;
      var lows = [];
      for (var i = 0; i < n; i++) {
        if (scores[i][h] < low) { low = scores[i][h]; lows = [i]; }
        else if (scores[i][h] === low) lows.push(i);
      }
      var atStake = 1 + carry;
      var entry = { hole: h + 1, played: true, low: low, lows: lows, atStake: atStake, winner: null, carried: false };
      if (lows.length === 1) {
        entry.winner = lows[0];
        won[lows[0]] += atStake;
        carry = 0;
      } else if (options.carryover !== false) {
        entry.carried = true;
        carry = atStake;
      } else {
        carry = 0;
      }
      holes.push(entry);
      last = entry;
    }

    // Skins still riding after the last hole played.
    var leftover = { skins: carry, rule: options.leftover || 'none', to: [] };
    if (carry > 0 && last) {
      if (leftover.rule === 'split') {
        leftover.to = last.lows.slice();
        last.lows.forEach(function (p) { won[p] += carry / last.lows.length; });
      } else if (leftover.rule === 'playoff' && typeof options.playoffWinner === 'number' &&
                 options.playoffWinner >= 0 && options.playoffWinner < n) {
        leftover.to = [options.playoffWinner];
        won[options.playoffWinner] += carry;
      }
    }

    var total = won.reduce(function (a, b) { return a + b; }, 0);
    var value = options.value > 0 ? options.value : 0;
    var balances = won.map(function (s) {
      var amount = options.payout === 'pot'
        ? value * s - (value * total) / n
        : value * (n * s - total);
      return cents(amount);
    });
    return {
      holes: holes,
      skins: won,
      total: total,
      leftover: leftover,
      unclaimed: leftover.to.length ? 0 : carry,
      pot: options.payout === 'pot' ? cents(value * total) : null,
      ante: options.payout === 'pot' ? cents((value * total) / n) : null,
      balances: balances
    };
  }

  /* ---------- nassau ---------- */

  function sideScore(scores, side, h) {
    var best = Infinity;
    for (var i = 0; i < side.length; i++) best = Math.min(best, scores[side[i]][h]);
    return best;
  }

  // One match play bet over holes from..to (1-based, inclusive).
  // results[h] is 0 or 1 for the side that won the hole, -1 for a half,
  // null when the hole was not played.
  function match(results, from, to) {
    var lead = 0;   // positive: side 0 is up
    for (var h = from; h <= to; h++) {
      var r = results[h - 1];
      if (r === null) return { from: from, to: to, status: 'live', lead: lead, thru: h - 1 };
      if (r === 0) lead += 1;
      else if (r === 1) lead -= 1;
      var left = to - h;
      if (Math.abs(lead) > left) {
        return {
          from: from, to: to, status: 'won', winner: lead > 0 ? 0 : 1, lead: lead, thru: h,
          margin: left > 0 ? Math.abs(lead) + ' and ' + left : Math.abs(lead) + ' up'
        };
      }
    }
    return { from: from, to: to, status: 'push', winner: null, lead: 0, thru: to, margin: 'All square' };
  }

  // Holes where an automatic press opens on this nine: [{ from, by }].
  function autoPresses(results, first, last) {
    var presses = [];
    var start = first;   // first hole of the latest bet on this nine
    var lead = 0;
    for (var h = first; h < last; h++) {
      var r = results[h - 1];
      if (r === null) break;
      if (h < start) continue;
      if (r === 0) lead += 1;
      else if (r === 1) lead -= 1;
      // 2 down in the latest bet, with a hole to start on that is not the
      // last of the nine.
      if (Math.abs(lead) === 2 && h + 1 < last) {
        presses.push({ from: h + 1, by: lead > 0 ? 1 : 0 });
        start = h + 1;
        lead = 0;
      }
    }
    return presses;
  }

  // options: { sides: [[players], [players]], stake: dollars,
  //            presses: 'none' | 'auto' | 'manual', manual: [{ from, by }] }
  function nassau(scores, options) {
    var sides = options.sides;
    var everyone = sides[0].concat(sides[1]);
    var results = [];
    for (var h = 0; h < HOLES; h++) {
      if (!holePlayed(scores, everyone, h)) { results.push(null); continue; }
      var a = sideScore(scores, sides[0], h);
      var b = sideScore(scores, sides[1], h);
      results.push(a < b ? 0 : b < a ? 1 : -1);
    }

    var presses = [];
    if (options.presses === 'auto') {
      presses = autoPresses(results, 1, 9).concat(autoPresses(results, 10, 18));
    } else if (options.presses === 'manual' && Array.isArray(options.manual)) {
      presses = options.manual.filter(function (p) {
        return p && p.from % 1 === 0 && p.from >= 2 && p.from <= 18 && p.from !== 10;
      }).map(function (p) { return { from: p.from, by: p.by === 1 ? 1 : 0 }; })
        .sort(function (x, y) { return x.from - y.from; });
    }

    var bets = [
      { name: 'Front nine', kind: 'front', from: 1, to: 9 },
      { name: 'Back nine', kind: 'back', from: 10, to: 18 },
      { name: 'Overall', kind: 'overall', from: 1, to: 18 }
    ];
    presses.forEach(function (p, i) {
      bets.push({ name: 'Press ' + (i + 1), kind: 'press', from: p.from, to: p.from <= 9 ? 9 : 18, by: p.by });
    });

    var units = [0, 0];
    var decided = 0;
    bets = bets.map(function (bet) {
      var m = match(results, bet.from, bet.to);
      if (m.status === 'won') {
        units[m.winner] += 1;
        units[1 - m.winner] -= 1;
      }
      if (m.status !== 'live') decided += 1;
      return {
        name: bet.name, kind: bet.kind, from: bet.from, to: bet.to, by: bet.by === undefined ? null : bet.by,
        status: m.status, winner: m.status === 'won' ? m.winner : null, margin: m.margin || null, thru: m.thru
      };
    });

    var stake = options.stake > 0 ? options.stake : 0;
    var count = 0;
    for (var s = 0; s < sides.length; s++) count = Math.max(count, sides[s].length);
    var balances = range(scores.length).map(function () { return 0; });
    // Each player on the losing side pays the stake; each winner collects it.
    sides.forEach(function (side, i) {
      side.forEach(function (p) { balances[p] = cents(stake * units[i]); });
    });
    return {
      results: results,
      bets: bets,
      units: units,
      inPlay: cents(stake * bets.length * count),
      decided: decided,
      balances: balances
    };
  }

  /* ---------- wolf ---------- */

  function rotationHoles(n) {
    return Math.floor(HOLES / n) * n;
  }

  // options: { players: 3 | 4 | 5, stake: dollars per point,
  //            lastHoles: 'fewest' | 'rotate',
  //            calls: [{ type: 'partner' | 'lone' | 'blind', partner: player }] per hole }
  function wolf(scores, options) {
    var n = options.players;
    var players = range(n);
    var collected = players.map(function () { return 0; });
    var net = players.map(function () { return 0; });
    var holes = [];
    var even = rotationHoles(n);

    for (var h = 0; h < HOLES; h++) {
      var who = h % n;
      var byFewest = false;
      if (h >= even && options.lastHoles !== 'rotate') {
        byFewest = true;
        who = 0;
        for (var p = 1; p < n; p++) if (collected[p] < collected[who]) who = p;
      }
      var call = options.calls ? options.calls[h] : null;
      var entry = { hole: h + 1, wolf: who, byFewest: byFewest, played: false, call: null, partner: null, result: null,
        collected: players.map(function () { return 0; }), net: players.map(function () { return 0; }) };

      var type = call && (call.type === 'lone' || call.type === 'blind' || call.type === 'partner') ? call.type : null;
      var partner = type === 'partner' ? call.partner : null;
      var callOk = type && (type !== 'partner' || (partner % 1 === 0 && partner >= 0 && partner < n && partner !== who));
      if (!callOk || !holePlayed(scores, players, h)) { holes.push(entry); continue; }

      var pack = type === 'partner' ? [who, partner] : [who];
      var rest = players.filter(function (x) { return pack.indexOf(x) === -1; });
      var a = sideScore(scores, pack, h);
      var b = sideScore(scores, rest, h);
      entry.played = true;
      entry.call = type;
      entry.partner = partner;
      entry.result = a < b ? 'wolf' : b < a ? 'others' : 'push';

      if (entry.result !== 'push') {
        var winners = entry.result === 'wolf' ? pack : rest;
        var losers = entry.result === 'wolf' ? rest : pack;
        var times = type === 'blind' ? 2 : 1;
        winners.forEach(function (w) {
          entry.collected[w] = losers.length * times;
          entry.net[w] = losers.length * times;
        });
        losers.forEach(function (l) { entry.net[l] = -winners.length * times; });
      }
      players.forEach(function (x) {
        collected[x] += entry.collected[x];
        net[x] += entry.net[x];
      });
      holes.push(entry);
    }

    var stake = options.stake > 0 ? options.stake : 0;
    return {
      holes: holes,
      collected: collected,
      net: net,
      balances: net.map(function (x) { return cents(stake * x); })
    };
  }

  /* ---------- who pays whom ---------- */

  // balances in cents, positive is owed money. Pays the biggest debt to the
  // biggest credit until everyone is square: at most players − 1 payments.
  function settle(balances) {
    var left = balances.map(function (b, i) { return { player: i, amount: Math.round(b) }; });
    var pay = [];
    for (var guard = 0; guard < balances.length * 2; guard++) {
      var debtor = null;
      var creditor = null;
      left.forEach(function (x) {
        if (x.amount < 0 && (!debtor || x.amount < debtor.amount)) debtor = x;
        if (x.amount > 0 && (!creditor || x.amount > creditor.amount)) creditor = x;
      });
      if (!debtor || !creditor) break;
      var amount = Math.min(-debtor.amount, creditor.amount);
      pay.push({ from: debtor.player, to: creditor.player, amount: amount });
      debtor.amount += amount;
      creditor.amount -= amount;
    }
    return pay;
  }

  // Cents as money: 1250 → "$12.50", 500 → "$5", −750 → "−$7.50".
  function money(amount) {
    var a = Math.abs(Math.round(amount));
    var text = a % 100 === 0 ? String(a / 100) : (a / 100).toFixed(2);
    return (amount < 0 ? '−' : '') + '$' + text;
  }
  function signed(amount) {
    return amount > 0 ? '+' + money(amount) : money(amount);
  }
  // Skins can split, so 2.5 is possible; whole numbers print whole.
  function count(n) {
    return n % 1 === 0 ? String(n) : (Math.round(n * 100) / 100).toString();
  }

  /* ---------- the worked scorecards from our guides ---------- */

  var PARS = [4, 5, 3, 4, 4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 5, 4, 3, 4];
  var EXAMPLES = {
    skins: {
      names: ['A', 'B', 'C', 'D'],
      scores: [
        [4, 5, 3, 4, 5, 4, 6, 2, 5, 4, 5, 4, 4, 5, 5, 4, 3, 5],
        [5, 5, 3, 4, 3, 5, 5, 3, 5, 4, 6, 3, 5, 5, 4, 4, 4, 5],
        [4, 6, 4, 5, 4, 4, 5, 4, 4, 4, 5, 3, 6, 5, 5, 5, 3, 4],
        [5, 4, 3, 5, 4, 4, 6, 3, 6, 4, 6, 4, 5, 5, 5, 3, 3, 5]
      ],
      value: 5
    },
    nassau: {
      names: ['A', 'B'],
      scores: [
        [4, 5, 3, 5, 4, 4, 6, 3, 4, 5, 5, 3, 4, 4, 6, 4, 4, 4],
        [5, 5, 4, 4, 4, 5, 5, 3, 5, 4, 4, 4, 4, 5, 5, 4, 3, 5]
      ],
      stake: 5,
      manual: [{ from: 4, by: 1 }, { from: 12, by: 0 }, { from: 15, by: 1 }]
    },
    // The guide gives each hole's call and result. These scores produce them.
    wolf: {
      names: ['A', 'B', 'C', 'D'],
      scores: [
        [4, 5, 3, 4, 5, 5, 6, 3, 4, 5, 6, 4, 4, 5, 6, 4, 3, 3],
        [4, 5, 3, 5, 4, 3, 6, 4, 5, 5, 6, 4, 4, 4, 5, 4, 4, 4],
        [5, 5, 4, 5, 4, 5, 5, 3, 4, 4, 4, 4, 4, 5, 6, 4, 3, 4],
        [5, 5, 3, 4, 5, 5, 5, 4, 5, 4, 6, 2, 4, 4, 5, 5, 4, 4]
      ],
      calls: [
        { type: 'partner', partner: 1 }, { type: 'partner', partner: 2 }, { type: 'lone' }, { type: 'partner', partner: 0 },
        { type: 'partner', partner: 3 }, { type: 'lone' }, { type: 'partner', partner: 3 }, { type: 'partner', partner: 1 },
        { type: 'partner', partner: 2 }, { type: 'partner', partner: 0 }, { type: 'lone' }, { type: 'blind' },
        { type: 'partner', partner: 1 }, { type: 'partner', partner: 3 }, { type: 'partner', partner: 0 }, { type: 'lone' },
        { type: 'partner', partner: 2 }, { type: 'lone' }
      ],
      stake: 1
    }
  };

  return {
    HOLES: HOLES,
    PARS: PARS,
    EXAMPLES: EXAMPLES,
    isScore: isScore,
    strokesOnHole: strokesOnHole,
    validStrokeIndexes: validStrokeIndexes,
    playingHandicaps: playingHandicaps,
    netScores: netScores,
    skins: skins,
    match: match,
    autoPresses: autoPresses,
    nassau: nassau,
    rotationHoles: rotationHoles,
    wolf: wolf,
    settle: settle,
    money: money,
    signed: signed,
    count: count
  };
});
